import { Component, OnInit } from '@angular/core';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'inicio-sesion',
  templateUrl: './inicio-sesion.component.html',
  styleUrls: ['./inicio-sesion.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('fadeIn', [

      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [
        style({ opacity: 0 }),
        animate(300)
      ]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave',
        animate(300, style({ opacity: 0 })))
    ])
  ]
})
export class InicioSesionComponent implements OnInit {

  public loginForm: FormGroup;
  constructor(private formBuilder: FormBuilder, private autenticacionService: AutenticacionService) { }

  public ngOnInit(): void {
    this.inicializarForm();
  }

  private inicializarForm(): void {
    this.loginForm = this.formBuilder.group({
      user: new FormControl('', [Validators.required]),
      password: new FormControl('', Validators.required)
    });
  }

  public obtenerMensajeValidacion(controlName: string): string {
    let error = '';
    const control = this.loginForm.get(controlName);
    control.errors.email
    if (control.touched && control.errors != null) {
      error = "El campo es requerido.";
    }
    return error;
  }

  public iniciarSesion(): void {
    this.autenticacionService.iniciarSesion(this.loginForm.get('user').value, this.loginForm.get('password').value);
  }


}
